function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  colorInterpolationFilters: "auto",
  id: "atoms-icon-hardness_inline_svg__a"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)",
  filter: "url(#atoms-icon-hardness_inline_svg__a)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M3.704 14.333a.149.149 0 00.148-.148v-2.66a6.54 6.54 0 013.324-1.114 16.498 16.498 0 002.554-.348c.081-.017 2.026-.44 3.518-2.254.219-.265-.013-.67-.36-.6-.555.115-2.14.232-4.827-1.178-1.611-.846-2.928-.959-3.889-.837a.89.89 0 10-1.506-.639.89.89 0 00.593.836v8.794c0 .082.067.148.148.148h.297zm-.148-9.481a.297.297 0 01-.297-.296.297.297 0 01.593 0 .297.297 0 01-.296.296zm.296 5.972V5.846c.874-.196 2.213-.194 3.933.71 2.202 1.155 3.746 1.34 4.62 1.303C11.12 9.15 9.626 9.48 9.61 9.483a16.182 16.182 0 01-2.463.337 7.11 7.11 0 00-3.294 1.004z",
  fill: "#212121",
  fillRule: "nonzero"
}));

function SvgAtomsIconHardnessinline(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default SvgAtomsIconHardnessinline;